import React, { Component } from "react";
import Navbar from "./global-components/navbar";
import PageHeader from "./global-components/page-header";
import InvestorRelations from "./shop-components/investor-relations";
import CallToActionV1 from "./section-components/call-to-action-v1";
import Footer from "./global-components/footer";
import { withAppData } from "../app/withAppData";
import StockTicker from "./global-components/stock-ticker";

class InvestorRelationsV1 extends Component {
  render() {
    const { companyInfo, investorRelations, loading, lang } =
      this.props.appData;
    const companyInfos = Array.isArray(companyInfo?.companyInfos)
      ? companyInfo.companyInfos
      : [];
    const investorRelationsData = Array.isArray(
      investorRelations?.investorRelations
    )
      ? investorRelations.investorRelations
      : [];
    return (
      <div>
        <Navbar />
        <PageHeader
          lang={lang}
          headertitle={
            lang === "tr" ? "Yatırımcı İlişkileri" : "Investor Relations"
          }
          rightSlot={<StockTicker lang={lang} />}
        />
        <InvestorRelations
          companyInfos={companyInfos}
          investorRelationsData={investorRelationsData}
          loading={loading}
        />
        <CallToActionV1 />
        <Footer />
      </div>
    );
  }
}

export default withAppData(InvestorRelationsV1);
